
import { MapPin } from "lucide-react";

interface CompanyAddressProps {
  company: {
    street?: string | null;
    postal_code?: string | null;
    city?: string | null;
    country?: string | null;
    address?: string | null; // For backward compatibility
  };
}

export const CompanyAddressDisplay = ({ company }: CompanyAddressProps) => {
  // Handle both structured address and legacy address field
  const hasStructuredAddress = company.street || company.city || company.postal_code || company.country;
  
  const addressDisplay = hasStructuredAddress ? (
    <div>
      {company.street && <div>{company.street}</div>}
      <div>
        {company.postal_code && <span>{company.postal_code} </span>}
        {company.city && <span>{company.city}</span>}
      </div>
      {company.country && <div>{company.country}</div>}
    </div>
  ) : (
    <span>{company.address || "-"}</span>
  );
  
  return (
    <div className="flex items-start">
      <MapPin className="h-5 w-5 text-gray-400 mr-3 mt-0.5 flex-shrink-0" />
      {addressDisplay}
    </div>
  );
};
